module.exports = __webpack_public_path__ + "static/media/navidad12.3a372957.jpg";